/**
 * Unidade logada, gravada no localStorage pela tela de Login e enviada em toda
 * requisição no header X-Unidade-Id (ver src/services/requestApi.ts).
 */
export function getUnidadeLogadaId(): number | null {
  try {
    const unidade = JSON.parse(localStorage.getItem("UnidadeLogada") as any);
    return unidade?.id ?? null;
  } catch {
    return null;
  }
}
